/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import React from "react";
import { FaRegCalendarCheck } from "react-icons/fa";
import { PiBagFill } from "react-icons/pi";
import { MdAccessTime } from "react-icons/md";
const Reason = () => {
  return (
    <div className="p-0 m-0 box-border bg-[#F7F8F8] py-16">
      <div className="w-[90%] mx-auto">
        <h2 className="text-background font-Inter text-2xl lg:text-5xl text-center font-semibold pt-6 pb-4">
          Why Choose Us
        </h2>
        <p className=" text-lg lg:text-2xl text-center font-Poppins font-medium">
          Working Round The Clock To Serve You Better
        </p>
        <div className="flex flex-col lg:flex-row lg:gap-4 justify-between items-center">
          <div className=" w-[340px] sm:w-[350px] h-[270px] my-6 lg:my-12 bg-white font-Inter shadow-xl rounded-md">
            <div className="w-[310px] mx-auto h-full">
              <div className="w-[60px] h-[60px] rounded-full flex justify-center items-center ml-4 my-8 bg-[#E8EEFC]">
                <FaRegCalendarCheck className="text-background font-bold text-3xl" />
              </div>
              <h3 className="pb-4 font-semibold text-3xl pl-3">
                Always On Time
              </h3>
              <p className="font-medium text-[grey] pl-3">
                At PMC we have customer interest at heart and we are always here
                to serve you
              </p>
            </div>
          </div>
          <div className=" w-[340px] sm:w-[350px] h-[270px] mb-6 lg:my-12 bg-white font-Inter shadow-xl rounded-md">
            <div className="w-[310px] mx-auto h-full">
              <div className="w-[60px] h-[60px] rounded-full flex justify-center items-center ml-4 my-8 bg-[#E8EEFC]">
                <PiBagFill className="text-background font-bold text-3xl" />
              </div>
              <h3 className="pb-4 font-semibold text-3xl pl-4">Dedication</h3>
              <p className="font-medium text-[grey] pl-4">
                We have a team of dedicated professionals
              </p>
            </div>
          </div>
          <div className=" w-[340px] sm:w-[350px] h-[270px] mb-6 lg:my-12 bg-white font-Inter shadow-xl rounded-md">
            <div className="w-[310px] mx-auto h-full">
              <div className="w-[60px] h-[60px] rounded-full flex justify-center items-center ml-4 my-8 bg-[#E8EEFC]">
                <MdAccessTime className="text-background font-bold text-3xl" />
              </div>
              <h3 className="pb-4 font-semibold text-3xl pl-4">
                24/7 Availability
              </h3>
              <p className="font-medium text-[grey] pl-4">
                We will endeavour to respond to your queries outside our
                official working hours
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reason;
